import { i18n } from '@/shared/i18n';

// Functions, not consts: resolving at call time is what lets the copy follow a
// language change instead of freezing at import.
export const trackersPageTitle = (): string =>
  i18n.t('trackers:trackers.trackersConstants.trackers');

export const trackersPageDescription = (): string =>
  i18n.t('trackers:trackers.trackersConstants.manageAndTrackYourWork');
